import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import CommonFooter from "../../../core/common/footer/commonFooter";
import Table from "../../../core/pagination/datatable";
import { API_BASE_URL, API_NOTIFY_URL } from "../Config/Config";
import { Spin } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { Select as AntSelect } from "antd";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";

const Devices = () => {
  const [devices, setDevices] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(1);
  const [devicesCount, setDevicesCount] = useState([]);
  const [devicesLoading, setDevicesLoading] = useState(false);
  const [devicesCountLoading, setDevicesCountLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [selectedClientType, setSelectedClientType] = useState(null);
  const [addLoading, setAddLoading] = useState(false);

  const columns = [
    {
      title: "Super Id",
      dataIndex: "SuperId",
      sorter: (a, b) => (a?.SuperId || 0) - (b?.SuperId || 0),
    },
    {
      title: "Client",
      dataIndex: "OrgName",
      render: (_, record) => {
        const truncated =
          record?.OrgName?.length > 45
            ? record?.OrgName?.substring(0, 45) + "..."
            : record?.OrgName;
        return (
          <div className="d-flex align-items-center gap-4">
            <span
              className={
                record?.IsActive
                  ? "badge bg-success rounded-circle"
                  : "badge bg-danger rounded-circle"
              }
              style={{
                width: 15,
                height: 15,
                display: "inline-block",
              }}
            ></span>
            <span title={record?.OrgName}>{truncated}</span>
          </div>
        );
      },

      sorter: (a, b) => (a?.OrgName || "").localeCompare(b?.OrgName || ""),
    },
   
    {
      title: "Serial No",
      dataIndex: "SerialNo",
      sorter: (a, b) => a.SerialNo.localeCompare(b.SerialNo),
      render: (text) => {
        const truncated =
          text?.length > 20 ? text.substring(0, 20) + "..." : text;
        return <span title={text}>{truncated}</span>;
      },
    },
    {
      title: "MC Id",
      dataIndex: "MachineId",
      sorter: (a, b) => a.MachineId.localeCompare(b.MachineId),
    },
    {
      title: "Device Model",
      dataIndex: "DeviceModel",
      sorter: (a, b) => a.DeviceModel.localeCompare(b.DeviceModel),
    },
    {
      title: "Port No",
      dataIndex: "PortNo",
      sorter: (a, b) => a.PortNo - b.PortNo,
    },

    {
      title: "Actions",
      render: (_, record) => (
        <div className="action-icon d-inline-flex align-items-center">
          <Link
            to="#"
            className="me-2 p-2 d-flex align-items-center border rounded"
            data-bs-toggle="modal"
            data-bs-target="#Notification"
            onClick={() => fetchCompanyDetails(record)}
          >
            <i className="ti ti-bell" />
          </Link>
        </div>
      ),
    },
  ];

  const getDevices = async () => {
    setDevicesLoading(true);

    try {
      const url = `${API_BASE_URL}/api/getdevices?isactive=${selectedStatus}`;
      console.log("Fetching URL:", url);

      const response = await fetch(url);
      const result = await response.json();

      console.log("API Response:", result);

      const data = result?.ResultData || [];
      console.log("Parsed Devices:", data);

      setDevices(data);
    } catch (error) {
      console.error("Error fetching devices:", error);
    } finally {
      setDevicesLoading(false);
    }
  };

  const getDevicescount = async () => {
    setDevicesCountLoading(true);

    try {
      const url = `${API_BASE_URL}/api/getdevicetypecount`; // No params here
      console.log("Fetching URL:", url);

      const response = await axios.get(url);
      const data = response.data?.ResultData || [];
      setDevicesCount(data);
    } catch (error) {
      console.error("Error fetching device count:", error);
    }

    setDevicesCountLoading(false);
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };
  const resetDeviceForm = () => {
    setDeviceForm({
      SuperId: "",
      SerialNo: "",
      MachineId: "",
      DeviceName: "",
      DeviceType: "",
      DeviceModel: "",
      ServerPort: "",
      IsSpecial: "",
    });

    setSelectedClientType(null);
  };

  const [deviceForm, setDeviceForm] = useState({
    SuperId: "",
    SerialNo: "",
    MachineId: "",
    DeviceName: "",
    DeviceType: "",
    DeviceModel: "",
    ServerPort: "",
    IsSpecial: "0",
  });

  const [NotifytModalData, setNotifyModalData] = useState({
    OrgName: "",
    PrimaryEmailAddr: "",
    PrimaryMobile: "",
    Subject: "",
    Message: "",
  });

  const fetchCompanyDetails = (record) => {
    let finalMessage = "";
    if (!record.IsActive) {
      finalMessage = `
    Hi, ${record.OrgName}

    We noticed that your Device is currently *inactive*.
    Please contact our support team to reactivate your services 
    and resume normal operations.

     Device Details:
    Model: ${record.DeviceModel}
    Serial No: ${record.SerialNo}
    MachineId: ${record.MachineId}

    Warm regards,
    PerennialCode Support Team

    Contact Us:
    Phone: 8297230010
    Email: support@perennialcode.in
    `;
    } else if (record.IsActive) {
      finalMessage = `
    Hi, ${record.OrgName}

    Your device appears to be *offline*, and attendance data 
    has not been received for the past few days.

    Please check the following:
    • Power supply to the device
    • Internet/network connection
    • Device wiring and connectivity

    Device Details:
    Model: ${record.DeviceModel}
    Serial No: ${record.SerialNo}
    MachineId: ${record.MachineId}

    If the issue persists, kindly contact our support team.

    Warm regards,
    PerennialCode Support Team

    Contact Us:
    Phone: 8297230010
    Email: support@perennialcode.in
    `;
    }

    setNotifyModalData({
      OrgName: record.OrgName || "",
      PrimaryEmailAddr: record.PrimaryEmailAddr || "",
      PrimaryMobile: record.PrimaryMobile || "",
      Subject: "Important Notification From Our Team",
      Message: finalMessage,
    });
  };

  const sendWhatsAppNotification = async () => {
    if (!NotifytModalData.PrimaryMobile || !NotifytModalData.Message) {
      alert("Contact number and message are required!");
      return;
    }

    try {
      const payload = {
        number: NotifytModalData.PrimaryMobile,
        client: NotifytModalData.OrgName,
        subject: NotifytModalData.Subject,
        message: NotifytModalData.Message,
      };

      console.log("Sending JSON:", payload); // Debugging

      const res = await axios.post(
        `${API_NOTIFY_URL}pcode/sendWhatsAppmessageHealthcheck`,
        payload,
      );

      if (res.data.success) {
        alert("WhatsApp message sent successfully!");
      } else {
        alert("Failed to send message!");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }
  };

  const saveDevice = async () => {
    setAddLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/adddevice`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(deviceForm),
      });

      const result = await response.json();

      if (result.ResultData[0].Status === "1") {
        Swal.fire({
          title: "Device Added Successfully",
          text: "The new device has been added.",
          icon: "success",
          confirmButtonText: "OK",
        });
        document.getElementById("closeModel").click();

        resetDeviceForm();
        getDevices();
      } else {
        Swal.fire({
          title: "Failed to Add Device",
          text: "Something went wrong while adding the device.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error adding device:", error);
    } finally {
      setAddLoading(false);
    }
  };

  const fetchClintes = async () => {
    try {
      // setLoadingService(true);
      const res = await fetch(`${API_BASE_URL}/api/getorganizationtype`);

      if (!res.ok) throw new Error("Failed to fetch ClientTypes");
      const data = await res.json();

      if (data.Status === true) {
        setClients(
          data.ResultData.map((item) => ({
            label: item.OrgName, // FIXED
            value: String(item.SuperId),
          })),
        );
      }
    } catch (error) {
      console.error("Error fetching service types:", error);
    } finally {
      // setLoadingService(false);
    }
  };

  const handleChange1 = (e) => {
    setNotifyModalData({
      ...NotifytModalData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChange = (e) => {
    setDeviceForm({
      ...deviceForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckbox = (e) => {
    setDeviceForm({
      ...deviceForm,
      IsSpecial: e.target.checked ? "1" : "0",
    });
  };

  const handleClientSelect = (value) => {
    setSelectedClientType(value);
    setDeviceForm({
      ...deviceForm,
      SuperId: value.value,
    });
  };
  useEffect(() => {
    getDevices();
    fetchClintes();
    getDevicescount();
  }, []);

  useEffect(() => {
    getDevices();
  }, [selectedStatus]);

  useEffect(() => {
    const modal = document.getElementById("add_plans");

    const handleClose = () => {
      resetDeviceForm();
    };

    if (modal) {
      modal.addEventListener("hidden.bs.modal", handleClose);
    }

    return () => {
      if (modal) {
        modal.removeEventListener("hidden.bs.modal", handleClose);
      }
    };
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      {addLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Spin size="large" />
        </div>
      )}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Devices</h4>
                <h6>Manage your devices</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {/* <li>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Refresh"
                >
                  <i data-feather="rotate-ccw" className="feather-rotate-ccw" />
                </Link>
              </li> */}
               <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
              <li>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                >
                  <i data-feather="chevron-up" className="feather-chevron-up" />
                </Link>
              </li>
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#add_plans"
                className="btn btn-primary"
                title="Add"
              >
                <i className="ti ti-circle-plus" style={{ fontSize: "18px" }}></i>
              
              </Link>
            </div>
          </div>

          <div className="row">
            {/* Total Plans */}
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Total Devices
                      </p>{" "}
                      {devicesCountLoading ? (
                        <Spin size="small" />
                      ) : (
                        <h4>{devicesCount[4]?.DeviceCount}</h4>
                      )}
                    </div>
                  </div>
                  <div>
                    <span className="avatar avatar-lg bg-primary flex-shrink-0">
                      <i className="ti ti-devices fs-3" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Plans */}
            {/* Total Plans */}
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Biomax Devices
                      </p>{" "}
                      {devicesCountLoading ? (
                        <Spin size="small" />
                      ) : (
                        <h4>{devicesCount[0]?.DeviceCount}</h4>
                      )}
                    </div>
                  </div>
                  <div>
                    <span className="avatar avatar-lg bg-success flex-shrink-0">
                      <i className="ti ti-fingerprint fs-3" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Plans */}
            {/* Inactive Plans */}
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Essl Devices
                      </p>
                      {devicesCountLoading ? (
                        <Spin size="small" />
                      ) : (
                        <h4>{devicesCount[1]?.DeviceCount}</h4>
                      )}
                    </div>
                  </div>
                  <div>
                    <span className="avatar avatar-lg bg-warning flex-shrink-0">
                      <i className="ti ti-cpu fs-3" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* /Inactive Companies */}
            {/* No of Plans  */}
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        ZKTec Devices
                      </p>
                      {devicesCountLoading ? (
                        <Spin size="small" />
                      ) : (
                        <h4>{devicesCount[2]?.DeviceCount}</h4>
                      )}
                    </div>
                  </div>
                  <div>
                    <span className="avatar avatar-lg bg-skyblue flex-shrink-0">
                      <i className="ti ti-device-analytics fs-3" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* /No of Plans */}
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set py-3"></div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <AntSelect
                    placeholder="Select Status"
                    value={selectedStatus}
                    onChange={handleStatusChange}
                    style={{ width: 200 }}
                  >
                    <AntSelect.Option value={1}>Active</AntSelect.Option>
                    <AntSelect.Option value={0}>Inactive</AntSelect.Option>
                    <AntSelect.Option value={null}>
                      All Devices
                    </AntSelect.Option>
                  </AntSelect>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                {devicesLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "250px",
                    }}
                  >
                    <Spin size="large" />
                  </div>
                ) : Array.isArray(devices) && devices.length > 0 ? (
                  <Table columns={columns} dataSource={devices}  />
                ) : (
                  <p className="text-center text-muted">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>

      {/* Add New Device */}
      <div className="modal fade" id="add_plans">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add New Device</h4>
              <button
                id="closeModel"
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => resetDeviceForm()}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3 ">
                      <label className="form-label">
                        Client <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="w-100"
                        options={clients}
                        placeholder="Choose"
                        value={selectedClientType}
                        onChange={handleClientSelect}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        popupClassName=""
                        dropdownStyle={{ zIndex: 9999 }}
                        dropdownRender={(menu) => (
                          <div style={{ zIndex: 9999, position: "relative" }}>
                            {menu}
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3 ">
                      <label className="form-label">
                        Serial No
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="SerialNo"
                        value={deviceForm.SerialNo}
                        onChange={handleChange}
                        placeholder="Enter Serial or Mac ID"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3 ">
                      <label className="form-label">
                        Machine Id
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="MachineId"
                        value={deviceForm.MachineId}
                        onChange={handleChange}
                        placeholder="Enter Machine or Terminal ID"
                        pattern="\d{2}"
                        maxLength={2}
                        title="Machine ID must be exactly 2 digits"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3 ">
                      <label className="form-label">Branch</label>
                      <input
                        type="text"
                        className="form-control"
                        name="DeviceName"
                        value={deviceForm.DeviceName}
                        onChange={handleChange}
                        placeholder="Enter Location"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <div className="d-flex justify-content-between">
                        <label className="form-label">
                          Device Type <span className="text-danger">*</span>
                        </label>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        name="DeviceType"
                        value={deviceForm.DeviceType}
                        onChange={handleChange}
                        placeholder="Enter Device Type"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3 ">
                      <label className="form-label">
                        Device Model<span className="text-danger"> *</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type="text"
                          className="form-control"
                          name="DeviceModel"
                          value={deviceForm.DeviceModel}
                          onChange={handleChange}
                          placeholder="Enter Device Model"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="mb-3 ">
                      <label className="form-label">
                        Server Port:<span className="text-danger"> *</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type="text"
                          className="form-control"
                          name="ServerPort"
                          value={deviceForm.ServerPort}
                          onChange={handleChange}
                          placeholder="Enter Server Port"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label className="form-label">Is Special Device</label>

                      <div className="form-check mt-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="specialDevice"
                          checked={deviceForm.IsSpecial === "1"}
                          onChange={handleCheckbox}
                        />

                        <label
                          className="form-check-label"
                          htmlFor="specialDevice"
                        >
                          Yes
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={() => resetDeviceForm()}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={saveDevice}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* View Notification */}
      <div className="modal fade" id="Notification">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="text-gray-9 fw-medium">
                Send Notification To Client
              </h3>
              <button
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className=" fw-medium">Client</label>
                    <input
                      type="text"
                      className="form-control"
                      name="OrgName"
                      value={NotifytModalData.OrgName}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className=" fw-medium">Subject</label>
                    <input
                      type="text"
                      className="form-control"
                      name="Subject"
                      value={NotifytModalData.Subject}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="fw-medium">Email To</label>
                    <input
                      type="email"
                      className="form-control"
                      name="PrimaryEmailAddr"
                      value={NotifytModalData.PrimaryEmailAddr}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="fw-medium">Contact</label>
                    <input
                      type="text"
                      className="form-control"
                      name="PrimaryMobile"
                      value={NotifytModalData.PrimaryMobile}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="mb-3">
                    <label className="fw-medium">Notify Message Content</label>
                    <textarea
                      className="form-control"
                      rows="5"
                      name="Message"
                      value={NotifytModalData.Message}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="text-center">
                  <button
                    className="btn btn-success text-white"
                    onClick={sendWhatsAppNotification}
                  >
                    Notify
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Devices;
